import { render, staticRenderFns } from "./BasePhoneNumber.vue?vue&type=template&id=6f81b066&"
import script from "./BasePhoneNumber.vue?vue&type=script&lang=js&"
export * from "./BasePhoneNumber.vue?vue&type=script&lang=js&"
import style0 from "./BasePhoneNumber.vue?vue&type=style&index=0&lang=stylus&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports